/**
 * スライドショーローディング時のエリア確保とローディング状態管理
 */

(function() {
  'use strict';

  // スライドショー管理オブジェクト
  const slideshowManager = {
    slideshows: new Map(),

    // スライドショーの初期化
    initializeSlideshow: function(slideshowElement) {
      if (!slideshowElement || this.slideshows.has(slideshowElement)) return;

      const slideshowId = slideshowElement.dataset.sectionId ||
                         slideshowElement.getAttribute('data-slideshow') ||
                         'slideshow-' + Date.now();

      // 初期状態でローディングクラスを追加
      slideshowElement.classList.add('slideshow-loading');

      const slideshowData = {
        element: slideshowElement,
        id: slideshowId,
        isLoaded: false,
        images: [],
        loadedImages: 0,
        startTime: Date.now()
      };

      // スライドショー内の画像を取得
      const images = slideshowElement.querySelectorAll('.slideshow-slide__image, img[data-rimg], [data-rimg-template]');
      slideshowData.images = Array.from(images);

      this.slideshows.set(slideshowElement, slideshowData);

      // 画像の読み込み状況を監視
      this.monitorImageLoading(slideshowData);

      // エリア確保の確認
      this.ensureAreaReservation(slideshowData);
    },

    // エリア確保の確認と調整
    ensureAreaReservation: function(slideshowData) {
      const { element } = slideshowData;
      const wrapper = element.querySelector('.slideshow__wrapper');

      if (!wrapper) return;

      // 高さが設定されていない場合のフォールバック
      const computedStyle = window.getComputedStyle(wrapper);
      const currentHeight = parseInt(computedStyle.minHeight) || 0;

      if (currentHeight < 200) {
        // 最小高さを確保
        wrapper.style.minHeight = '300px';
      }

      // レイアウトシフト防止のため、幅も確保
      if (!wrapper.style.width && !element.classList.contains('full-width')) {
        const parentWidth = element.offsetWidth;
        if (parentWidth > 0) {
          wrapper.style.width = parentWidth + 'px';
        }
      }
    },

    // 画像読み込み監視
    monitorImageLoading: function(slideshowData) {
      const { element, images } = slideshowData;

      if (images.length === 0) {
        // 画像がない場合は少し遅延してロード完了
        setTimeout(() => this.onSlideshowLoadComplete(slideshowData), 300);
        return;
      }

      let loadedCount = 0;
      const totalImages = images.length;

      const checkImageLoaded = () => {
        loadedCount++;
        slideshowData.loadedImages = loadedCount;

        // プログレス表示（オプション）
        this.updateLoadingProgress(slideshowData, loadedCount, totalImages);

        // 全画像が読み込まれたかチェック
        if (loadedCount >= totalImages) {
          this.onSlideshowLoadComplete(slideshowData);
        }
      };

      images.forEach((img, index) => {
        // 既に読み込み済みの画像をチェック
        if (this.isImageLoaded(img)) {
          checkImageLoaded();
        } else {
          // 読み込み完了イベントをリッスン
          img.addEventListener('load', checkImageLoaded);
          img.addEventListener('error', checkImageLoaded); // エラーでも進行

          // rimg用のカスタムイベントもリッスン
          img.addEventListener('rimg:loaded', checkImageLoaded);
          img.addEventListener('rimg:error', checkImageLoaded);
        }
      });

      // フォールバック: 8秒後に強制完了
      setTimeout(() => {
        if (!slideshowData.isLoaded) {
          console.warn(`Slideshow ${slideshowData.id}: Loading timeout, forcing completion`);
          this.onSlideshowLoadComplete(slideshowData);
        }
      }, 8000);
    },

    // 画像が読み込み済みかチェック
    isImageLoaded: function(img) {
      if (img.complete && img.naturalWidth > 0) return true;
      if (img.hasAttribute('data-rimg') && img.getAttribute('data-rimg') === 'loaded') return true;
      return false;
    },

    // ローディング進捗の更新（オプション）
    updateLoadingProgress: function(slideshowData, loaded, total) {
      const { element } = slideshowData;
      const progress = Math.round((loaded / total) * 100);

      // カスタムイベントを発火
      const event = new CustomEvent('slideshow:progress', {
        detail: {
          slideshowId: slideshowData.id,
          progress: progress,
          loaded: loaded,
          total: total
        }
      });
      element.dispatchEvent(event);
    },

    // スライドショーローディング完了処理
    onSlideshowLoadComplete: function(slideshowData) {
      if (slideshowData.isLoaded) return;

      slideshowData.isLoaded = true;
      const { element } = slideshowData;
      const loadTime = Date.now() - slideshowData.startTime;

      // 最小表示時間を確保（UX向上のため）
      const minDisplayTime = 500;
      const delay = Math.max(0, minDisplayTime - loadTime);

      setTimeout(() => {
        // ローディングクラスを削除し、ロード完了クラスを追加
        element.classList.remove('slideshow-loading');
        element.classList.add('slideshow-loaded');

        // インライン幅スタイルを削除（レスポンシブ復帰）
        const wrapper = element.querySelector('.slideshow__wrapper');
        if (wrapper && wrapper.style.width) {
          wrapper.style.width = '';
        }

        // ロード完了後のクリーンアップ（アニメーション完了後に実行）
        setTimeout(() => {
          element.classList.remove('slideshow-loaded');
          // アニメーション完了後の状態を確実に保持
          const imageWrappers = element.querySelectorAll('.slideshow-slide__image-wrapper');
          imageWrappers.forEach(wrapper => {
            wrapper.style.opacity = '1';
            wrapper.style.transform = 'scale(1)';
          });
        }, 3500); // アニメーション時間(2.5s) + 最大遅延(0.8s) + バッファ(0.2s)

        // カスタムイベントを発火
        const event = new CustomEvent('slideshow:loaded', {
          detail: {
            slideshowId: slideshowData.id,
            element: element,
            loadTime: loadTime + delay
          }
        });
        element.dispatchEvent(event);

      }, delay);
    },

    // 新しいスライドショーを検索して初期化
    scanForSlideshows: function() {
      const slideshowElements = document.querySelectorAll('[data-slideshow], .slideshow');

      slideshowElements.forEach(element => {
        if (!this.slideshows.has(element)) {
          this.initializeSlideshow(element);
        }
      });
    },

    // 手動でスライドショーローディング完了をトリガー
    triggerLoadComplete: function(slideshowElement) {
      const slideshowData = this.slideshows.get(slideshowElement);
      if (slideshowData) {
        this.onSlideshowLoadComplete(slideshowData);
      }
    },

    // デバッグ用ステータス取得
    getStatus: function() {
      const status = {};
      this.slideshows.forEach((data, element) => {
        status[data.id] = {
          isLoaded: data.isLoaded,
          totalImages: data.images.length,
          loadedImages: data.loadedImages,
          loadTime: Date.now() - data.startTime
        };
      });
      return status;
    }
  };

  // DOM準備完了時の処理
  function onDOMReady() {
    slideshowManager.scanForSlideshows();

    // MutationObserverで動的に追加されるスライドショーを監視
    if (window.MutationObserver) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // 追加されたノード自体がスライドショーかチェック
              if (node.matches && node.matches('[data-slideshow], .slideshow')) {
                slideshowManager.initializeSlideshow(node);
              }
              // 追加されたノード内のスライドショーをチェック
              const nestedSlideshows = node.querySelectorAll && node.querySelectorAll('[data-slideshow], .slideshow');
              if (nestedSlideshows) {
                nestedSlideshows.forEach(el => slideshowManager.initializeSlideshow(el));
              }
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // ウィンドウロード完了時の追加処理
  function onWindowLoad() {
    // 未処理のスライドショーがあれば強制完了
    slideshowManager.slideshows.forEach((slideshowData) => {
      if (!slideshowData.isLoaded) {
        setTimeout(() => slideshowManager.onSlideshowLoadComplete(slideshowData), 500);
      }
    });
  }

  // リサイズ時の処理
  function onWindowResize() {
    slideshowManager.slideshows.forEach((slideshowData) => {
      if (!slideshowData.isLoaded) {
        slideshowManager.ensureAreaReservation(slideshowData);
      }
    });
  }

  // イベントリスナーの設定
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDOMReady);
  } else {
    onDOMReady();
  }

  window.addEventListener('load', onWindowLoad);
  window.addEventListener('resize', onWindowResize);

  // Shopifyテーマ固有のイベント
  document.addEventListener('shopify:section:load', function(event) {
    // 新しくロードされたセクション内のスライドショーを初期化
    const slideshowElements = event.target.querySelectorAll('[data-slideshow], .slideshow');
    slideshowElements.forEach(el => slideshowManager.initializeSlideshow(el));
  });

  // グローバル関数として公開
  window.slideshowManager = slideshowManager;

})();